import React from 'react';
import { useIntl } from 'react-intl';
import { Title } from '../styles';

export const CapacityTitle = (): JSX.Element => {
  const intl = useIntl();

  return <Title data-testid="capacity-title">{intl.formatMessage({ id: 'capacity' })}</Title>;
};
